import { LoadingSpinner } from "@newsela/angelou";
import PropTypes from "prop-types";

import findMatchingTextSetMember from "@/view/utils/findMatchingTextSetMember";
import useTextSetsGet from "@/view/utils/useTextSetsGet";
import UpdateTextSetOption from "./../UpdateTextSetOption";

const propTypes = {
  contentId: PropTypes.string,
  contentType: PropTypes.string,
  currentLevel: PropTypes.object,
};

const UpdateTextSetOptions = ({ contentId, contentType, currentLevel }) => {
  const { data: textSets = [], loading } = useTextSetsGet();
  const textSetsMembers = textSets?.members;

  // Sorting by name/title of textSet
  const sortTextSets = (textSets) =>
    textSets?.sort((a, b) => {
      const inA = findMatchingTextSetMember(
        a,
        contentId,
        contentType,
        currentLevel,
      );
      const inB = findMatchingTextSetMember(
        b,
        contentId,
        contentType,
        currentLevel,
      );
      if (inA === inB) {
        return 0;
      } else if (inA) {
        return 1;
      } else {
        return -1;
      }
    });

  const sortedUserTextSets = sortTextSets(textSetsMembers);
  const renderUserTextSetOptions = () =>
    sortedUserTextSets?.map((textSet) => (
      <UpdateTextSetOption
        key={textSet.id}
        contentId={contentId}
        contentType={contentType}
        currentLevel={currentLevel}
        textSet={textSet}
      />
    ));

  return <>{loading ? <LoadingSpinner /> : renderUserTextSetOptions()}</>;
};

UpdateTextSetOptions.propTypes = propTypes;

export default UpdateTextSetOptions;
